"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/hooks/useAuth";
import Loading from "@/components/common/Loading/Loading";
import { useLanguage } from "@/contexts/useLanguage";

export default function HomePage() {
  const router = useRouter();
  const { isAuthenticated, isLoading } = useAuth();
  const { t } = useLanguage();
  useEffect(() => {
    // Only redirect if not loading
    if (!isLoading) {
      if (isAuthenticated) {
        // Redirect authenticated users to dashboard
        router.push("/dashboard");
      } else {
        // Redirect unauthenticated users to login
        router.push("/login");
      }
    }
  }, [isAuthenticated, isLoading, router]);

  // Show loading state while checking authentication or redirecting
  return <Loading message={t("common.loading")} />;
}
